module.exports = __webpack_public_path__ + "static/img/2969_phase_function_Paper_PointsHejduk_Prediction.88e333e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/2969_phase_function_Paper_PointsHejduk_Prediction.png
// module id = 7HlL
// module chunks = 0